import Vue from 'vue';
import Vuex from  'vuex';
import { state, actions, getters, modules, mutations } from './globalStore';

Vue.use(Vuex);

export default new Vuex.Store({
    state,
    actions,
    getters,
    modules,
    mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js